import { Component, NgZone, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { S3ImageUploadService } from 'app/shared/s3-image-upload.service';
import { GlobalVariable } from 'app/main/globals';
import {AspHelpUsImproveService} from './asp-help-us-improve.service';
import { ActivatedRoute, Router } from '@angular/router';
/// <reference types="dom-mediacapture-record" />

declare global {
  interface Window {
    SpeechRecognition: any;
    webkitSpeechRecognition: any;
  }
}

@Component({
  selector: 'app-asp-help-us-improve',
  templateUrl: './asp-help-us-improve.component.html',
  styleUrls: ['./asp-help-us-improve.component.scss']
})
export class AspHelpUsImproveComponent implements OnInit {
  private mediaRecorder!: MediaRecorder;
  private audioChunks: BlobPart[] = [];
  roleType: string;
  finalMood: string = '';
  finalReasons: string[] = [];

  selectedMood: 'happy' | 'okay' | 'unhappy' | '' = '';
  selectedReasons: string[] = [];

  feedbackText: string = '';
  recordedText = '';

  uploadedPhotos: string[] = []; 
  uploadedAudio: string[] = []; 
  photosAdded: boolean = false;

  isRecording = false;
  hasRecorded = false;
  isSubmitted: boolean = false;

  isHelpUsKnowSidebarOpen = false;
  isHelpUsKnowStepTwoOpen = false;
  showTellUsMoreSidebar = false;
  isThankyouSidebarOpen = false;
  currentStep = 1;

  recognition: any;
   audioUrl: string | null = null;

  feedbackOptions?: {
    happy?: { heading: string; subHeading: string; feedback: string[][] };
    okay?: { heading: string; subHeading: string; feedback: string[][] };
    unhappy?: { heading: string; subHeading: string; feedback: string[][] };
  };

  constructor(
    private http: HttpClient,
    private s3ImageUploadService: S3ImageUploadService,
    private aspHelpUsImproveService: AspHelpUsImproveService,
    private router: Router,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.getFeedbackOptions();
    this.setupSpeechRecognition();
    this.roleType = localStorage.getItem('roleType');
  }

  // ------------------ API & FEEDBACK DATA ------------------
  private groupFeedback(feedback: string[]): string[][] {
    return [
      [feedback[0]],
      [feedback[1]],
      [feedback[2]],
      feedback.slice(3, 5)
    ].filter(line => line.length > 0);
  }

  getFeedbackOptions() {
    this.http
     this.aspHelpUsImproveService.getFeedbackOptions().subscribe({
        next: (res) => {
          try {
            let val = res.value;
            val = val.replace(/""(u[0-9A-F]{4})/gi, '"$1');
            val = val.replace(/(u[0-9A-F]{4}),/gi, '$1",');
            val = val.replace(/\}\s*,\s*\{/, '},');
            val = val.replace(/([{,]\s*)([A-Za-z0-9_-]+)\s*:/g, '$1"$2":');

            const parsed = JSON.parse(val);
            const decodeUnicode = (str: string) =>
              str.replace(/u([0-9A-F]{4})/gi, (_, grp) => {
                try {
                  return String.fromCharCode(parseInt(grp, 16));
                } catch {
                  return _;
                }
              });

            this.feedbackOptions = {
              happy: {
                heading: decodeUnicode(parsed.Happy.heading),
                subHeading: decodeUnicode(parsed.Happy['sub-heading']),
                feedback: this.groupFeedback(parsed.Happy.feedback.map(decodeUnicode))
              },
              okay: {
                heading: decodeUnicode(parsed.Okay.heading),
                subHeading: decodeUnicode(parsed.Okay['sub-heading']),
                feedback: this.groupFeedback(parsed.Okay.feedback.map(decodeUnicode))
              },
              unhappy: {
                heading: decodeUnicode(parsed.Unhappy.heading),
                subHeading: decodeUnicode(parsed.Unhappy['sub-heading']),
                feedback: this.groupFeedback(parsed.Unhappy.feedback.map(decodeUnicode))
              }
            };
          } catch (err) {
            console.error('Error parsing feedback options:', err);
          }
        },
        error: (err) => console.error(err)
      });
  }

  // ------------------ STEP NAVIGATION ------------------
  openHelpUsKnowSidebar() {
    this.isHelpUsKnowSidebarOpen = true;
    this.currentStep = 1;
  }
  closeHelpUsKnowSidebar(){
    this.isHelpUsKnowSidebarOpen = false;
  }

  openStepTwoSidebar(mood: string) {
    this.selectedMood = mood as 'happy' | 'okay' | 'unhappy';
    this.finalMood = this.selectedMood;
    this.isHelpUsKnowSidebarOpen = false;
    this.isHelpUsKnowStepTwoOpen = true;
  }
  closeHelpUsKnowStepTwoSidebar(){
    this.isHelpUsKnowStepTwoOpen = false;
  }

  openTellUsMoreSidebar() {
    this.finalReasons = [...this.selectedReasons];
    this.showTellUsMoreSidebar = true;
    this.isHelpUsKnowStepTwoOpen = false;
  }
  closeshowTellUsMoreSidebar(){
    this.showTellUsMoreSidebar = false;
  }

  goBackToStepOne() {
    this.isHelpUsKnowStepTwoOpen = false;
    this.isHelpUsKnowSidebarOpen = true;
  }

  goBackToPreviousSidebar() {
    this.showTellUsMoreSidebar = false;
    this.isHelpUsKnowStepTwoOpen = true;
  }

  toggleReason(reason: string) {
    if (this.selectedReasons.includes(reason)) {
      this.selectedReasons = this.selectedReasons.filter(r => r !== reason);
    } else {
      this.selectedReasons.push(reason);
    }
  }

  // ------------------ TEXT INPUT ------------------
  onFeedbackTextChange(event: any) {
    this.feedbackText = event.target.value;
  }

  // ------------------ SPEECH RECOGNITION ------------------
  setupSpeechRecognition() {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;

      this.recognition.onresult = (event: any) => {
        this.recordedText = event.results[0][0].transcript;
        this.hasRecorded = true;
      };

      this.recognition.onend = () => {
        this.isRecording = false;
      };
    }
  }

  // toggleRecording() {
  //   if (!this.recognition) return;
  //   if (this.isRecording) {
  //     this.recognition.stop();
  //     this.isRecording = false;
  //     this.hasRecorded = true;
  //   } else {
  //     this.recordedText = '';
  //     this.isRecording = true;
  //     this.hasRecorded = false;
  //     this.recognition.start();
  //   }
  // }

//   toggleRecording() {
//   if (!this.recognition) return;

//   if (this.isRecording) {
//     // Stop both speech recognition and audio recording
//     this.recognition.stop();
//     if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
//       this.mediaRecorder.stop(); // ⬅ triggers uploadRecordedAudio()
//     }
//     this.isRecording = false;
//     this.hasRecorded = true;
//   } else {
//     this.recordedText = '';
//     this.isRecording = true;
//     this.hasRecorded = false;

//     this.recognition.start();
//     this.audioChunks = [];

//     navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
//       this.mediaRecorder = new MediaRecorder(stream);

//       this.mediaRecorder.ondataavailable = event => {
//         if (event.data.size > 0) {
//           this.audioChunks.push(event.data);
//         }
//       };

//       this.mediaRecorder.onstop = () => {
//         const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
//         this.uploadRecordedAudio(audioBlob);
//       };

//       this.mediaRecorder.start();
//     });
//   }
// }
 recordingDuration: number = 0; // seconds
  timerInterval: any;
  audio!: HTMLAudioElement;
  isPlaying = false;
  progress = 0;
  currentTimeDisplay = '0:00';
  totalTimeDisplay = '0:00';
toggleRecording() {
    if (this.isRecording) {
      clearInterval(this.timerInterval);
      this.mediaRecorder.stop();
      this.isRecording = false;
      this.hasRecorded = true;
    } else {
      this.isRecording = true;
      this.hasRecorded = false;
      this.recordingDuration = 0;
      this.audioChunks = [];

     this.timerInterval = setInterval(() => {
  this.ngZone.run(() => {
    this.recordingDuration++;
    this.totalTimeDisplay = this.formatTime(this.recordingDuration);
  });
}, 1000);

navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
  this.mediaRecorder = new MediaRecorder(stream);

  this.mediaRecorder.ondataavailable = e => {
    if (e.data.size > 0) this.audioChunks.push(e.data);
  };

  this.mediaRecorder.onstop = () => {
    const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
    this.audioUrl = URL.createObjectURL(audioBlob);
     this.uploadRecordedAudio(audioBlob);

    // Create player
    this.audio = new Audio(this.audioUrl);

    // Set total length immediately from timer
    const totalSeconds = this.recordingDuration;
    this.totalTimeDisplay = this.formatTime(totalSeconds);

    // Update progress safely
    this.audio.ontimeupdate = () => {
      this.ngZone.run(() => {
        const denom = Number.isFinite(this.audio.duration) && this.audio.duration > 0
          ? this.audio.duration
          : totalSeconds; // fallback to recorded duration

        this.progress = (this.audio.currentTime / denom) * 100;
        this.currentTimeDisplay = this.formatTime(this.audio.currentTime);
      });
    };

    this.audio.onended = () => this.isPlaying = false;
  };

  this.mediaRecorder.start();
});
    }
  }

  togglePlay() {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
    } else {
      this.audio.play();
      this.isPlaying = true;
    }
  }

  get formattedDuration() {
    const minutes = Math.floor(this.recordingDuration / 60);
    const seconds = this.recordingDuration % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  private formatTime(sec: number) {
    const minutes = Math.floor(sec / 60);
    const seconds = Math.floor(sec % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
  
getSegmentClass(segmentNumber: number) {
  const segmentThresholds = [20, 50, 75, 100];
  const segmentProgress = segmentThresholds[segmentNumber - 1];
  const prevThreshold = segmentNumber === 1 ? 0 : segmentThresholds[segmentNumber - 2];

  // Mark completed segments
  if (this.progress >= segmentProgress) {
    return 'completed';
  }

  // Mark the segment that's currently playing
  if (this.isPlaying && this.progress >= prevThreshold && this.progress < segmentProgress) {
    return 'playing';
  }

  // Otherwise idle
  return 'idle';
}

deleteRecording() {
  // Stop playback if playing
  if (this.audio && !this.audio.paused) {
    this.audio.pause();
  }

  // Clear values
  this.audioUrl = null;
  this.isPlaying = false;
  this.progress = 0;
  this.currentTimeDisplay = '00:00';
  this.totalTimeDisplay = '00:00';
  this.isRecording = false;
  this.hasRecorded = false;
}

//  toggleRecording() {
//     if (!this.recognition) return;

//     if (this.isRecording) {
//       clearInterval(this.timerInterval);

//       this.recognition.stop();
//       if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
//         this.mediaRecorder.stop();
//       }
//       this.isRecording = false;
//       this.hasRecorded = true;

//     } else {
//       this.recordedText = '';
//       this.isRecording = true;
//       this.hasRecorded = false;
//       this.recordingDuration = 0;

//       // ✅ Start timer inside NgZone so Angular updates view
//       this.timerInterval = setInterval(() => {
//         this.ngZone.run(() => {
//           this.recordingDuration++;
//         });
//       }, 1000);

//       this.recognition.start();
//       this.audioChunks = [];

//       navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
//         this.mediaRecorder = new MediaRecorder(stream);

//         this.mediaRecorder.ondataavailable = event => {
//           if (event.data.size > 0) {
//             this.audioChunks.push(event.data);
//           }
//         };

//         this.mediaRecorder.onstop = () => {
//           const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
//           this.uploadRecordedAudio(audioBlob);
//         };

//         this.mediaRecorder.start();
//       });
//     }
//   }

//   get formattedDuration() {
//     const minutes = Math.floor(this.recordingDuration / 60);
//     const seconds = this.recordingDuration % 60;
//     return `${minutes}:${seconds.toString().padStart(2, '0')}`;
//   }

  

  // ------------------ FILE UPLOAD TO S3 ------------------
  private uploadFileToS3(file: File, type: 'image' | 'audio') {
    this.s3ImageUploadService.getPresignedUrl(file.name).subscribe({
      next: (response) => {
        const presignedUrl = response[0]?.signedUrl;
        const link = response[0]?.link;

        if (presignedUrl && link) {
          this.http.put(presignedUrl, file, { headers: { 'Content-Type': file.type } })
            .subscribe({
              next: () => {
                if (type === 'image') {
                  this.uploadedPhotos.push(link);
                  this.photosAdded = true;
                } else if (type === 'audio') {
                  this.uploadedAudio.push(link);
                }
              },
              error: (err) => console.error(`Error uploading ${type}:`, err)
            });
        }
      },
      error: (err) => console.error(`Error getting presigned URL for ${type}:`, err)
    });
  }

  // ------------------ PHOTO UPLOAD ------------------
  onPhotosSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      Array.from(files).forEach((file: any) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          // Optional preview
        };
        reader.readAsDataURL(file);
        this.uploadFileToS3(file, 'image');
      });
    }
  }

  // ------------------ AUDIO UPLOAD ------------------
  uploadRecordedAudio(audioBlob: Blob) {
    console.log('Audio ready for upload', audioBlob);
    const file = new File([audioBlob], `feedback_${Date.now()}.wav`, { type: audioBlob.type || 'audio/wav' });
    this.uploadFileToS3(file, 'audio');
  }

  removePhoto(index: number) {
    this.uploadedPhotos.splice(index, 1);
    if (this.uploadedPhotos.length === 0) {
      this.photosAdded = false;
    }
  }

  // ------------------ FINAL SUBMIT ------------------
openThankyouSidebar() {
  const garageKey = localStorage.getItem('garageKey');
  const userKey = localStorage.getItem('spareUserKey');
console.log("this.uploadedAudio",this.uploadedAudio)
  const feedbackPayload = {
    feeling: this.finalMood || '',
    reasons: this.convertEmojisToLiteralUnicode(this.finalReasons.join(', ')),
    writtenFeedback: this.feedbackText || '',
    audioFeedback: typeof this.uploadedAudio?.[0] === 'string' ? this.uploadedAudio[0] : '',
    images: Array.isArray(this.uploadedPhotos)
      ? this.uploadedPhotos.map(photo => String(photo))
      : [],
    garageKey: garageKey || '',
    userKey: userKey || ''
  };

  console.log('API FEEDBACK PAYLOAD:', feedbackPayload);

  this.aspHelpUsImproveService.submitFeedback(feedbackPayload).subscribe({
    next: (res) => {
      console.log('Feedback submitted successfully:', res);
      this.isThankyouSidebarOpen = true;
      this.showTellUsMoreSidebar = false;
      this.isHelpUsKnowSidebarOpen = false;
      this.isHelpUsKnowStepTwoOpen = false;
      this.currentStep = 3;
     setTimeout(() => {
        this.router.navigate(['/home']).then(() => {
          window.location.reload();
        });
      }, 9000);
    },
    error: (err) => {
      console.error('Error submitting feedback:', err);
    }
  });
}


  closeThanksyouSidebar() {
    this.isThankyouSidebarOpen = false;
    this.showTellUsMoreSidebar = false;
    this.isHelpUsKnowSidebarOpen = false;
    this.isHelpUsKnowStepTwoOpen = false;
    this.ngOnInit();
  }
shareFeedbackViaWhatsApp() {
  const garageName = (localStorage.getItem('spareSelectedGarageName') || 'Our Garage').trim();

  const feedbackUrl = `${GlobalVariable.AUTOVERSE_WEB}/home?helpUsKnowMore=1`;
      // const feedbackUrl = `http://localhost:4200/home?helpUsKnowMore=1`;

    const message =
      `*Hi ${garageName} 👋*,\n\n` +
      `We’d love to hear how your recent experience with Autoverse was! 💬\n\n` +
      `Faced any issue? Have a suggestion? Just click below and share — even a quick voice note works.👇\n` +
      `🔗 ${feedbackUrl}\n\n` +
      `Your feedback helps us serve you better 🙏\n\n` +
      `*– Team Autoverse*`;

    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
}
convertEmojisToLiteralUnicode = (str: string): string => {
  return Array.from(str).map(char => {
    const code = char.codePointAt(0);
    // Only replace emoji / special symbols
    if (code && (code > 0x1F000 || (code >= 0x2100 && code <= 0x26FF))) {
      if (code <= 0xFFFF) {
        return 'u' + code.toString(16).toUpperCase().padStart(4, '0');
      }
      // Surrogate pairs
      const high = Math.floor((code - 0x10000) / 0x400) + 0xD800;
      const low = ((code - 0x10000) % 0x400) + 0xDC00;
      return 'u' + high.toString(16).toUpperCase().padStart(4, '0') +
             'u' + low.toString(16).toUpperCase().padStart(4, '0');
    }
    return char;
  }).join('');
};


}
